// @ts-nocheck
import * as GraphQLSchema from '../graphql-types';

import * as Operations from './search-workers-by-name-query.graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SearchWorkersByNameQueryVariables = GraphQLSchema.Exact<{
  after?: GraphQLSchema.InputMaybe<GraphQLSchema.Scalars['String']['input']>;
  first?: GraphQLSchema.InputMaybe<GraphQLSchema.Scalars['Int']['input']>;
  name: GraphQLSchema.Scalars['String']['input'];
}>;


export type SearchWorkersByNameQuery = { __typename?: 'Query', searchWorkersByName?: { __typename?: 'WorkerProfileSearchNodeConnection', totalCount: number, nodes?: Array<{ __typename?: 'WorkerProfileSearchNode', id: string, about?: string | null, normalizedType: string, combinedFeedback?: number | null, deliveredHourGroup?: string | null, distanceAway?: number | null, loyaltyName?: string | null, ratings?: Array<{ __typename?: 'Rating', id: string }> | null, clientFields: { __typename?: 'ClientFields', shortlisted?: boolean | null }, user: { __typename?: 'User', id: string, permalink: string, truncatedName: string, firstName: string, avatar?: { __typename?: 'Avatar', big?: string | null } | null } } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };


  @Injectable({
    providedIn: 'root'
  })
  export class SearchWorkersByNameQueryService extends Apollo.Query<SearchWorkersByNameQuery, SearchWorkersByNameQueryVariables> {
    document = Operations.SearchWorkersByNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }